import {createFileRoute} from "@tanstack/react-router";

import {serviceDetailMessages} from "../../-messages/service-detail.messages";
import {ServiceCompositionPage} from "./-page/service-composition.page";

export const Route = createFileRoute("/_app/engineering/services/$serviceId/composition/")({
  component: RouteComponent,
  staticData: {meta: {labelDescriptor: serviceDetailMessages.composition}},
});

function RouteComponent() {
  const {serviceId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <ServiceCompositionPage serviceId={serviceId} includeDeleted={includeDeleted} />;
}
